import { createFileRoute, notFound } from "@tanstack/react-router";
import { findArticle, type HelpArticle } from "@/lib/help-content";
import { HelpArticleLayout } from "@/components/marketing/help-article-layout";

const TITLE = "Connect Gmail or Outlook to CapitalDart";
const DESCRIPTION =
  "How email connections work, how to connect Outlook or Gmail, and exactly what CapitalDart reads once a mailbox is connected.";
const URL = "https://capitaldart.com/help/email-connections";

export const Route = createFileRoute("/help/email-connections")({
  loader: () => {
    const article = findArticle("email-connections");
    if (!article) throw notFound();
    return { article };
  },
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESCRIPTION },
      { name: "robots", content: "index, follow" },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESCRIPTION },
      { property: "og:url", content: URL },
      { property: "og:type", content: "article" },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: TITLE },
      { name: "twitter:description", content: DESCRIPTION },
    ],
    links: [{ rel: "canonical", href: URL }],
  }),
  component: EmailConnectionsPage,
});

function EmailConnectionsPage() {
  const { article } = Route.useLoaderData() as { article: HelpArticle };
  return <HelpArticleLayout article={article} />;
}
